import * as Sentry from '@sentry/react';

function initSentry() {
  let sampleRate = 1.0;
  if (import.meta.env.PROD) {
    sampleRate = 0.1;
  }
  Sentry.init({
    dsn: 'https://f9fcafaaf56a44887389656e55cce60a@o4509731008479232.ingest.us.sentry.io/4510936167677952',
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: sampleRate,
    enabled: true,
  });
}

function setUserContext(userId: string) {
  Sentry.setUser({ id: userId });
}

export { initSentry, setUserContext };
